require('./../fhApp/currentUser/currentUser');

"use strict";

angular.module('app.sessionTimeout.sessionTimeoutService', [
    'app.currentUser',
])
    .factory('sessionTimeoutService', [
        '$rootScope', '$document', 'currentUser', '$state',
        function ($rootScope, $document, currentUser, $state) {
            let service;

            service = {
                checkAndResetIdle: function () //user did something
                {
                    let d = new Date();
                    let n = d.getTime();  //n in ms

                    if(currentUser.is_logged_in() && n <= $rootScope.idleEndTime)
                    {
                        $rootScope.idleEndTime = n+(360*60*1000); //reset end time
                    } else if (currentUser.is_logged_in() && n > $rootScope.idleEndTime) {
                        $document.find('body').off('mousemove keydown DOMMouseScroll mousewheel mousedown touchstart'); //un-monitor events

                        currentUser.logout();
                        $state.go('app.sessionTimeout');
                        $rootScope.$broadcast('collapsableMenuTriggerCollapse');
                    }
                }
            };
            return service;
        }
    ]);


// WEBPACK FOOTER //
// ./app.v2/components/sessionTimeout/sessionTimeoutService.js